/* eslint-disable import/no-anonymous-default-export */
// import getcat from "../../utils/cat"  // не используется, т.к. cat определена в Term.js
// import getnp from "../../utils/spotify" // удалено

export default {
    commands: {
        echo: {
            description: 'Выводит переданный текст в консоль',
            usage: 'echo <текст>',
            fn: (...args) => args.join(" ")
        },
        // cat: { // закомментировано, т.к. команда cat уже определена в Term.js
        //     description: 'Get a cute cat image.',
        //     usage: 'cat',
        //     fn: async () => {
        //         const url = await getcat()
        //         window.open(url, '_blank')
        //         return "fetching cat...\ncat fetched successfully!"
        //     }
        // },
        about: {
            description: 'Обо мне',
            usage: 'about',
            fn: () => {
                return `Обо мне
---
Инди-разработчик на C++.
Люблю Linux, кембрийский период, игры и историю.
Ave!
---`
            }
        },
        github: {
            description: 'Открыть мой GitHub профиль',
            usage: 'github',
            fn: () => {
                window.open('https://github.com/MihailCoder/', '_blank')
                return "Открываю GitHub..."
            }
        },
        telegram: {
            description: 'Открыть мой Telegram',
            usage: 'telegram',
            fn: () => {
                window.open('https://t.me/center_of_retnec', '_blank')
                return "Открываю Telegram..."
            }
        },
        languages: {
            description: 'Языки, которые я знаю',
            usage: 'languages',
            fn: () => {
                return `
Языки, которые я знаю.
---
C++       | 25% (учу)
русский   | 100% (родной)
украинский| 0.1%
английский| A2+
---`
            }
        },
        skills: {
            description: 'Мои навыки',
            usage: 'skills',
            fn: () => {
                return `
Мои навыки (с юмором)
---
прокрастинация     | 100%
кодинг             | 30%
социальные навыки  | 10%
накручивание       | 100%
вдохновение        | 50%
пайка              | 20%
---`
            }
        },
        projects: {
            description: 'Мои проекты',
            usage: 'projects',
            fn: () => {
                return `
Мои проекты
---
Waiting For The Storm      | Консольная игра на C++       | C++
  -> https://github.com/MihailCoder/wtfs
Waiting For The Storm REMAKE| Ремейк первой игры           | C++
  -> https://github.com/MihailCoder/wftsR
---`
            }
        },
        editor: {
            description: 'Мой редактор кода',
            usage: 'editor',
            fn: () => {
                return `
Редактор: Visual Studio Code
Тема     : Catppuccin (или ваша)
Шрифт    : Consolas
---`
            }
        },
        repo: {
            description: 'Открыть репозиторий этого сайта',
            usage: 'repo',
            fn: () => {
                window.open("https://github.com/asrvd/AshTerm", '_blank')
                return "Открываю оригинальный репозиторий AshTerm..."
            }
        },
        credits: {
            description: 'Кто сделал этот шаблон',
            usage: 'credits',
            fn: () => {
                return `
Этот сайт построен на основе шаблона AshTerm
автор: asrvd (https://github.com/asrvd)
Спасибо ему за отличную работу! ❤️
---`
            }
        }
        // spotify удалён, т.к. у вас нет аккаунта
    },
    overwrites:{
        help: {
            description: 'Показать все доступные команды',
            usage: 'help',
        },
        cd: {
            description: 'Сменить директорию (понарошку)',
            usage: 'cd <директория>',
        },
        ls: {
            description: 'Показать содержимое текущей директории',
            usage: 'ls',
        },
        mkdir: {
            description: 'Создать директорию',
            usage: 'mkdir <имя>',
        },
        clear: {
            description: 'Очистить терминал',
            usage: 'clear'
        },
        cat: {
            description: 'Показать милого котика',
            usage: 'cat',
        }
    }
}